// Français pour le bandeau d'activité du tour en cours.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Answering…': 'Réponse en cours…',
  'tokens': 'tokens',
  'tool calls': 'appels d’outils',
}, 'ChatActivity');
